import { render, staticRenderFns } from "./DatasetDialog.vue?vue&type=template&id=4de533b7&scoped=true&"
import script from "./DatasetDialog.vue?vue&type=script&lang=js&"
export * from "./DatasetDialog.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDialog.vue?vue&type=style&index=0&id=4de533b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de533b7",
  null
  
)

export default component.exports